import { z } from 'zod';
import { REQUIRED_MESSAGE } from '@wyz/utils';

export const associatedCriteriaSchema = z.object({
  criterion: z.object({ id: z.string() }),
  values: z.array(
    z.object({
      id: z.string(),
      label: z.string(),
    }),
  ),
});
export const associatedCriteriaFormSchema = z.object({
  criterion: z.object({ id: z.string() }),
  values: z.array(z.string()).min(1, { message: REQUIRED_MESSAGE }),
});
